import React from 'react';
import { Route } from 'react-router';
import FaqContainer from 'split-chunk-loader?lazy!../Faq/FaqContainer';
import { lazify } from '../Common/Helper';

const Routes = (
    <Route
      label="FAQ"
      helmet={{
        title: 'Frequently Asked Questions Online',
        metaDescription: 'Our Top Frequently Asked Questions Online at {storeName} {guaranteeSlogan}'
      }}
      component={lazify(FaqContainer)} path='faq'>
    </Route>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes/FaqRoute.js